import React from 'react';

import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const GenericNavigationMainMenu = ({ path, items }) => {
  return (
    <div className="GenericNavigationMainMenu">
      <ul className="GenericNavigationMainMenu__items">
        {items.map((item) => {
          const href = item.getIn(['link', 'url'], '');
          const title = item.getIn(['link', 'title'], 'Untitled');

          return (
            <li
              key={`menu--main--menu-item-${title}:${href}`}
              className={c('menu--main--menu-item', {
                'menu--menu-item--active': item.getIn(['link', 'url']) === path,
              })}
            >
              <div className="GenericNavigationMainMenu__itemWrapper">
                <CoreLink href={href} className="GenericNavigationMainMenu__title">
                  {title}
                </CoreLink>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default GenericNavigationMainMenu;
